const SeatPlanSpaceShapes = {
	Circle: 1,
	Faced: 2,
	Divider: 3,
	Empty: 4
};

export default SeatPlanSpaceShapes;
